import axios from 'axios';

const apiURL = 'https://nfsigcliente.brasalrefrigerantes.com.br/api';
// const apiURL = 'http://localhost:9000';
// const apiURL = 'http://172.16.0.42:9000';

async function getCliente(cnpj) {
    const link = `${apiURL}/cliente/${cnpj}`;
    const response = await axios.get(link,
        JSON.stringify({ cnpj }),
        {
            headers: { 'Content-Type': 'application/json' }
        }
    );
    return response;
}

async function getClienteNota(codcli, rangeData) {
    const link = `${apiURL}/cliente/nota/${codcli}/${rangeData}`;
    
    try {
        const response = await axios.get(link, {
            headers: { 'Content-Type': 'application/json' }
        });

        return response;
    } catch (error) {
        console.error("Erro ao buscar cliente nota:", error);
        throw error;
    }
}

async function downloadArquivo(chave_acesso) {
    const fileUrl = `http://172.16.0.129:8090/oobj-rest-service/api/open/empresas/01612795000151/docs/prod/55/${chave_acesso}.pdf`;

    const link = `${apiURL}/download`;
    const response = await axios.post(link, { fileUrl, chave_acesso });
    return response.data;
}

async function downloadArquivoFront(chave_acesso) {
    try {
        const link = `${apiURL}/download/${chave_acesso}`;
        const response = await axios.get(link, {
            responseType: 'blob',
        });

        return response.data;
    } catch (error) {
        console.error("Error downloading the file", error);
    }
}

async function downloadArquivoFrontBoleto(chave_acesso) {
    try {
        const link = `${apiURL}/download/boleto/${chave_acesso}`;
        const response = await axios.get(link, {
            responseType: 'blob',
        });

        return response.data;
    } catch (error) {
        console.error("Error downloading the file", error);
        throw error;
    }
}

async function downloadTodasNotas(chaves) {
    try {
        const link = `${apiURL}/download/zip`;
        const response = await axios.post(
            link,
            { chaves },
            { responseType: "blob" }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const linkElement = document.createElement("a");
        linkElement.href = url;
        linkElement.setAttribute("download", `notas_${Date.now()}.zip`);
        document.body.appendChild(linkElement);
        linkElement.click();
        document.body.removeChild(linkElement);
    } catch (error) {
        console.error("Erro ao baixar todas as notas:", error);
        throw error;
    }
}

export {
    getCliente,
    getClienteNota,
    downloadArquivo,
    downloadArquivoFront,
    downloadArquivoFrontBoleto,
    downloadTodasNotas
}